import mobileItems from './mobile-menu';
import viewport from './viewport';
import fadeIn from './fadein-blocks';
import columns from "./stat-columns";

let trigered = 0;
let trigeredGenderCounter = 0;

export default {
  init() {
    // submenu click
    $('.header__nav-item--hasSub').on('click', function(e) {
      e.preventDefault();
      $(this).toggleClass('act');
    });

    // scroll down & back to top animations
    $('#scrollDown').on('click', function() {
      let target = $(this).closest('section').outerHeight();
      $("html, body").animate({ scrollTop: target }, "slow");
      return false;
    });

    $('#backToTop').on('click', function() {
      $("html, body").animate({ scrollTop: 0 }, "slow");
      return false;
    });

    // modal scroll down
    $('.modal-arrow_bottom').on('click', function() {
      let target = $(this).closest('.career-modal__hero').outerHeight();
      $(".modal__inner-wrap").animate({ scrollTop: target }, "slow");
      return false;
    });

    // news scroll down dynamic positon
    let nsi = $('.news-scroll');
    if(nsi.length > 0) {
      nsi.css('box-sizing', 'border-box');
      let nsiWith = nsi.width();
      nsi.css('left', 0 - nsiWith + 40);
    }

    // mobile menu
    $('.burger').on('click', function() {
      $(this).toggleClass('open');
      $('body').toggleClass('fixed');
      $('.mobileMenu').toggleClass('open');
      if($('#mobileLang').hasClass('open')) {
        $('#mobileLang').removeClass('open');
      }
    if($('.mobileMenu').hasClass('open')) {
      mobileItems.add('.mobileMenu', '.mobileMenu__item');
    } else {
      mobileItems.remove('.mobileMenu', '.mobileMenu__item');
    }
    });

    // mobile menu langs
    $('#mobileLang').on('click', function() {
      $(this).toggleClass('open');
    });

    // tables wrap
    $('.wswg_text').find('table').each(function() {
      $(this).before('<div class="scrollIcon onlyMob"><div class="scrollIcon__anim"></div>' + slideLeft + '</div>');
      $(this).wrap('<div class="tableOverflowWrap">');
    });

  },
  scrolling() {

    // titles
    let titleToAnimate = $('[data-animated-title]');
    titleToAnimate.each(function(){
      if(viewport.init(this)) {
        fadeIn.title(this);
      }
    });

    // media query 
    function mediaQ(x) {
      let upperTilesList = $('.tiles_list.upper');
      let lowerTilesList = $('.tiles_list.bottom');

      if (x.matches) {
        upperTilesList.addClass('found');
        lowerTilesList.addClass('found');

      } else {

       // home page tiles
        upperTilesList.each(function(){
          if(viewport.init(this)) {
            upperTilesList.addClass('found');
          }
        });
        
        lowerTilesList.each(function(){
          if(viewport.init(this)) {
            lowerTilesList.addClass('found');
          }
        });
        // home tiles END

        // order info page
        if($('.order_info__row').length > 0) {
          $('.order_info__row').each(function(index) {
            if(viewport.init($(this))) {
              $(this).addClass('found');
            }
          });
        }

         // projects page
        if($('.projects_item').length > 0) {
          $('.projects_item').each(function(index) {
            if(viewport.init($(this))) {
              $(this).addClass('found');
            }
          });
        }
      }
    }

    

    if($('.about-spider').length > 0 && viewport.init('.about-spider')) {
      $('.about-spider').addClass('found');
    }
  
    // career page
    if($('.employees_stat').length > 0 && viewport.init('.employees_stat') && trigered != 1) {
      trigered = 1;
      columns.init('.employees_stat__item', '.employees_stat');
    }
  
    if($('.gender_prog').length > 0 && viewport.init('.gender_prog') && trigeredGenderCounter != 1) {
      trigeredGenderCounter = 1;
      columns.count('.gender_prog .number');
    }
  
    if ($('.quality-sticky__background').length > 0) {
      $('.quality-sticky__background:not(.found)').each(function(i, fam){
        var famTop = $(fam).offset().top + (parseFloat($(fam).css('height'))/3);
        var mark = window.pageYOffset + (window.innerHeight * 8/9);
  
        if (mark > famTop) {
          $(fam).addClass('found');
        }
      });
    }

    // awards blocks
    if ($('.awards-slider__slide').length > 0) {
      var awardsDelay = 0;
      $('.awards-slider__slide').each(function(i, fam){
        var famTop = $(fam).offset().top + (parseFloat($(fam).css('height'))/3);
        var mark = window.pageYOffset + (window.innerHeight * 8/9);
  
        if (mark > famTop) {
          setTimeout(function(){ 
            $(fam).delay(awardsDelay).addClass('found'); 
          }, awardsDelay);
          awardsDelay += 250;
        }
      });
      awardsDelay = 0;
    }

   

    

    // quality page
    if($('.columns__list--bordered').length > 0) {
      $('.columns__list--bordered').each(function(index) {
        if(viewport.init($(this))) {
          $(this).addClass('found');
        }
      });
    }

    // change color of logo, menu items depending on section under
    const hook = window.pageYOffset ;
    if ($('.clr').length > 0 && $('[data-bg]').length > 0) {
      $('[data-bg]').each((idx, section) => {
        const top = $(section).offset().top - 65;
        const bottom = $(section).offset().top + parseFloat($(section).css('height'));
  
        if (hook >= top && hook < bottom) {
          $('.clr').attr('which', $(section).data('bg'));
        } else if ($(section).is('.footer') && window.pageYOffset + window.innerHeight > $(section).offset().top) {
          $('.clr').attr('which', $(section).data('bg'));
        }
      });
    }

    // media query
    var x = window.matchMedia("(max-width: 768px)")
    mediaQ(x)   
    x.addListener(mediaQ);
  }
}


